import request from "@/utils/request";

export default function agentSetSocketNum2TwoWaySocket(data) {
    return request({
        url: `/device/agentSocketManage/agentSetSocketNum2TwoWaySocket`,
        method: 'post',
        data
    })
}
